export default __webpack_public_path__ + "static/media/7.a9b814b5.jpg";